import { CustomCell, CustomRenderer, GridCellKind } from "@glideapps/glide-data-grid";
import SelectFiles from "../../Components/CargaPorTabla/SelectFiles";

export interface AdjuntoCellProps {
  readonly kind: "adjunto-cell";
  readonly id: string;
  readonly nombrePro?: { key: string; text: string } | null; // igual a tu IComboBoxOption
  readonly files: File[];
  readonly onMultipleFiles: (files: File[], rowId: string) => void;
  readonly onFileDelete: (index: number, rowId: string) => void;
}

export type AdjuntoCell = CustomCell<AdjuntoCellProps>;

export const AdjuntoCellRenderer: CustomRenderer<AdjuntoCell> = {
  kind: GridCellKind.Custom,

  isMatch: (cell): cell is AdjuntoCell =>
    cell.kind === GridCellKind.Custom && (cell.data as any).kind === "adjunto-cell",

  draw: (args, cell) => {
      const { ctx, rect } = args;
      const { files } = cell.data;
      // Centro de la celda
      const cx = rect.x + rect.width / 2;
      const cy = rect.y + rect.height / 2;

      const r = Math.min(rect.width, rect.height) * 0.25;

      ctx.save();
      ctx.strokeStyle = files.length > 0 ? "#0078d4" : "black";
      ctx.lineWidth = 2;

      // --- Dibuja la nube ---
      // La nube usa el nuevo radio 'r' más grande
      ctx.beginPath();
      ctx.arc(cx - r * 0.8, cy, r * 0.6, Math.PI * 0.5, Math.PI * 1.5);
      ctx.arc(cx, cy - r * 0.6, r * 0.6, Math.PI, Math.PI * 2);
      ctx.arc(cx + r * 0.8, cy, r * 0.6, Math.PI * 1.5, Math.PI * 0.5);
      ctx.closePath();
      ctx.stroke();

      // --- Flecha hacia arriba ---
      // Variable para desplazar verticalmente la flecha hacia abajo
      const offset_y = r * 0.5; // Ajusta este valor para más o menos desplazamiento

      ctx.beginPath();
      // Bajamos todas las coordenadas Y de la flecha sumando 'offset_y'
      ctx.moveTo(cx, cy + r * 0.8 + offset_y); 
      ctx.lineTo(cx, cy - r * 0.8 + offset_y);
      ctx.moveTo(cx - r * 0.4, cy - r * 0.3 + offset_y);
      ctx.lineTo(cx, cy - r * 0.8 + offset_y);
      ctx.lineTo(cx + r * 0.4, cy - r * 0.3 + offset_y);
      ctx.stroke();

      ctx.restore();

      return true;
  },

  provideEditor: () => {
    return p => {
      const { data } = p.value;

      const handleMouseDown = (e: React.MouseEvent) => {
        e.stopPropagation();
      };

      const handleFocus = (e: React.FocusEvent) => {
        e.stopPropagation();
      };

      return (
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
          onMouseDown={handleMouseDown}
          onFocus={handleFocus}
          onClick={handleMouseDown}
        >
          <SelectFiles
            files={data.files || []}
            onMultipleFiles={(fileList) =>
              data.onMultipleFiles(fileList, data.id)
            }
            onFileDelete={(index) => data.onFileDelete(index, data.id)}
            disabled={!data?.nombrePro?.key}
          />
        </div>
      );
    };
  },
};
